import { Component, OnInit } from '@angular/core';
import { VariablesService } from 'src/app/globalService/variables.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { GenericResult } from 'src/app/globalClass/generic-class.model';
import { AuthorizeService } from 'src/app/shared/authorizeService/authorize.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  changeForm: FormGroup;
  token: string;
  minimoCaracteres: number;
  constructor(
    private _variables: VariablesService,
    private _activateRoute: ActivatedRoute,
    private _authorizeService: AuthorizeService,
    private _toastr: ToastrService,
    private _router: Router,
    private _fb: FormBuilder,
  ) {
    this.loadData();
    this._activateRoute.params.subscribe(params => {
      this.token = params["to"];
      this.validateToken(this.token);
    });
  }

  ngOnInit() {
    this.initForm();
  }

  async loadData() {
    await this.loadVariables()
    this.initForm();
  }

  async loadVariables() {
    await this._variables.getVariables().then(
      r => {
        this.minimoCaracteres = this._variables.data.minimoCaracteresPass;
      }
    );
  }

  initForm() {
    this.changeForm = this._fb.group({
      token: this.token,
      contrasena1: ["", [Validators.required, Validators.minLength(this.minimoCaracteres), this.validatePassword]],
      contrasena2: ["", [this.equalsTo('contrasena1'), Validators.required]]
    })
  }

  private validatePassword(control: AbstractControl) {
    let hasNumber = /\d/.test(control.value);
    let hasUpper = /[A-Z]/.test(control.value);
    let hasLower = /[a-z]/.test(control.value);
    let hasEspecialCharacter = /[`~!@#$%^&*()_°¬|+\-=?;:'",.<>\{\}\[\]\\\/]/gi.test(control.value);
    let error = null;
    if (!hasNumber) {
      error = { ...error, notnumber: 'su contraseña debe contener almenos un número' };
    }
    if (!hasUpper) {
      error = { ...error, mayuscula: 'Su contraseña debe contener almenos una letra mayuscula' };
    }
    if (!hasLower) {
      error = { ...error, minuscula: 'Su contraseña debe contener almenos una letra minuscula' };
    }
    if (!hasEspecialCharacter) {
      error = { ...error, especial: 'Su contraseña debe contener almenos un caracter especial' };
    }
    return error;
  }

  equalsTo(otherField: string) {
    const validator = (formControl: FormControl) => {
      if (otherField == null) {
        throw new Error("Diligencie la información del campo");
      }
      if (!formControl.root || !(<FormGroup>formControl.root).controls) {
        return null;
      }
      const field = (<FormGroup>formControl.root).get(otherField);
      if (!field) {
        throw new Error('Diligencie la información del campo');
      }
      if (field.value !== formControl.value) {
        return { equalsTo: otherField }
      }
      return null;
    };
    return validator;
  }

  onSubmit() {
    this.changePassword();
  }

  changePassword() {
    // let tempForm = {
    //   token:this.token,
    //   contrasena1:this._cryptoJs.encrypt(this.changeForm.get("contrasena1").value),
    //   contrasena2:this._cryptoJs.encrypt(this.changeForm.get("contrasena2").value)
    // }
    let tempForm = {
      token: this.token,
      contrasena1: this.changeForm.get("contrasena1").value,
      contrasena2: this.changeForm.get("contrasena2").value
    }
    this._authorizeService.changePassword(tempForm).then(
      (r: GenericResult) => {
        if (r.error) {
          this._toastr.error("A ocurrido un error mientras realizabamos el proceso por favor vuelve a intentarlo mas tarde")
        } else {
          if (r.result == "Ok") {
            this._toastr.info("Tu contraseña se ha cambiado con exito, ingresa con tu usuario y el nuevo password");
            this._router.navigate(["/login"]);
          } else {
            if (r.result == "containNombre") {
              this._toastr.info("Tu contraseña no puede contener tu nombre");
              this.resetForm();
            } else if (r.result == "containDocumento") {
              this._toastr.info("Tu contraseña no puede contener tu número de documento");
              this.resetForm();
            } else if (r.result == "containEmail") {
              this._toastr.info("Tu contraseña no puede contener tu correo electrónico");
              this.resetForm();
            } else if (r.result == "oldPass") {
              this._toastr.info("Tu contraseña no puede ser igual a ninguna de tus ultimas 13 contraseñas usadas para el ingreso al Portal WtW.");
              this.resetForm();
            }
          }
        }
      }
    )
  };

  resetForm() {
    this.changeForm.reset();
  }

  validateToken(tkn) {
    this._authorizeService.validateToken(tkn).then(
      (r: GenericResult) => {
        if (r.error) {
          this._toastr.warning("Usted esta intentado ingresar a esta area de forma invalida");
          this._router.navigate(["/login"]);
        } else {
          if (r.result == "TokenTimeLose") {
            this._toastr.warning("El tiempo para canbiar su contraseña a caducado, por favor genere una nueva solicitud de cambio de contraseña");
            this._router.navigate(["/login"]);
          } else {
            this._toastr.success("Digite sus nuevas credenciales");
          }
        }
      }
      , error => {
        this._toastr.warning("Por favor verifique el estado de su conexión y vuelva a intentarlo.");
        this._router.navigate(["/login"]);
      }
    );
  }
}
